export const HOST_URL = process.env.REACT_APP_HOST_URL;
